<div class="pt-3 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_events">
  <h2>You do not have permission to manage event categories.</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="accountService.getMyAccount().can_manage_events && serverError === null">

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-info" role="alert" *ngIf="loadingReorder">
      Saving category order...
    </div>
  </div>

  <h2 class="d-inline-block">
    Event Categories
    <span *ngIf="loadingResults" class="text-secondary">- Loading...</span>
    <span *ngIf="!loadingResults && resultList && resultList.results">({{ resultList.count.toLocaleString() }})</span>
  </h2>

  <div class="float-right mb-1">
    <a class="btn btn-outline-primary mr-2"
       [href]="orgConfig.getOrganizationConfig() ? orgConfig.getOrganizationConfig().climber_app_base_url + 'schedule/catalog/' : '#'"
       target="_blank">
      View Catalog
    </a>
    <a class="btn btn-success" routerLink="/events/setup/categories/add">
      Create New Category
    </a>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Name</th>
        <th scope="col"># Event Types</th>
        <th></th>
      </tr>
      </thead>

      <tbody *ngIf="resultsPresent()">
      <tr *ngFor="let category of resultList.results;  let catIdx = index">
        <td>{{ category.name }}</td>
        <td>{{ category.assigned_event_types.length }}</td>
        <td class="table-button-cell">
          <div class="float-right">
            <button class="btn btn-secondary btn-sm mr-1"
                    [disabled]="catIdx === 0"
                    [class.disabled]="catIdx === 0"
                    ngbTooltip="Move to top"
                    (click)="shiftCategory(category, true, true)">
              &uarr;&uarr;&uarr;
            </button>
            <button class="btn btn-secondary btn-sm mr-1"
                    [disabled]="catIdx === 0"
                    [class.disabled]="catIdx === 0"
                    ngbTooltip="Move up one"
                    (click)="shiftCategory(category, true, false)">
              &uarr;
            </button>
            <button class="btn btn-secondary btn-sm mr-1"
                    ngbTooltip="Move down one"
                    [disabled]="catIdx >= (resultList.results.length - 1)"
                    [class.disabled]="catIdx >= (resultList.results.length - 1)"
                    (click)="shiftCategory(category, false, false)">
              &darr;
            </button>
            <button class="btn btn-secondary btn-sm mr-2"
                    ngbTooltip="Move to bottom"
                    [disabled]="catIdx >= (resultList.results.length - 1)"
                    [class.disabled]="catIdx >= (resultList.results.length - 1)"
                    (click)="shiftCategory(category, false, true)">
              &darr;&darr;&darr;
            </button>
            <a class="btn btn-outline-primary btn-sm"
               routerLink="/events/setup/categories/{{ category.id }}">
              Edit
            </a>
          </div>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!resultsPresent()">
      <tr>
        <td colspan="99">
          {{ loadingResults ? 'Loading...' : 'No categories' }}
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <!-- Removed (soft-deleted) categories, with a Restore action (PRO-1310). -->
  <div class="mt-5" *ngIf="removedCategories.length > 0">
    <h3>Removed Categories</h3>
    <p class="text-muted">
      These categories have been removed and are hidden from staff and climbers.
      Vouchers already issued in them stay valid. Restore a category to make it
      active again.
    </p>

    <div class="rounded-table-wrapper table-responsive-lg">
      <table class="table">
        <thead>
        <tr>
          <th scope="col">Name</th>
          <th scope="col"># Event Types</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let category of removedCategories">
          <td>{{ category.name }}</td>
          <td>{{ category.assigned_event_types.length }}</td>
          <td class="table-button-cell">
            <div class="float-right">
              <button class="btn btn-outline-primary btn-sm"
                      [disabled]="restoringCategoryId === category.id"
                      (click)="restoreCategory(category)">
                {{ restoringCategoryId === category.id ? 'Restoring...' : 'Restore' }}
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
